import dayjs from 'dayjs';
import * as React from 'react';

import useClock from '@/hooks/date/useClock';

import { Deadline } from './style';

const OrderDeadline: React.FC<{
  orderDeadline: dayjs.Dayjs;
}> = ({ orderDeadline }) => {
  const currentTime = useClock();

  if (orderDeadline.diff(currentTime, 's') < 0) {
    return <span>終了</span>;
  }

  if (orderDeadline.diff(currentTime, 'm') < 1) {
    return (
      <Deadline data-testid="dead-line-text">
        締切{orderDeadline.diff(currentTime, 's')}秒前
      </Deadline>
    );
  }

  if (orderDeadline.diff(currentTime, 's') <= 300) {
    return (
      <Deadline data-testid="dead-line-text">
        締切{orderDeadline.diff(currentTime, 'm')}分前
      </Deadline>
    );
  }

  if (orderDeadline.diff(currentTime, 's') <= 1800) {
    return (
      <span data-testid="dead-line-text">
        締切{orderDeadline.diff(currentTime, 'm')}分前
      </span>
    );
  }

  return <span data-testid="dead-line-text">発売中</span>;
};

export default React.memo(OrderDeadline);
